import { ExactKeys, GKVGeneralFormData } from "core/types";
import {
  ConversionJob,
  convertModelDefinition,
  valueDef,
} from "react-forms-state";

const model: Record<keyof GKVGeneralFormData, ConversionJob> = {
  ...valueDef("insurance_ik_number"),
  ...valueDef("hospital_ik_number"),
  // insured person
  ...valueDef("patient_first_name"),
  ...valueDef("patient_last_name"),
  ...valueDef("patient_street"),
  ...valueDef("patient_housenumber"),
  ...valueDef("patient_zipcode"),
  ...valueDef("patient_city"),
  ...valueDef("patient_phone_number"),
  ...valueDef("insurance_number"),
  ...valueDef("patient_birthdate"),

  // section one
  ...valueDef("insured_details_application_insurance_benefits"),
  ...valueDef("retirement_pension_applied"),
  ...valueDef("retirement_pension_company"),
  ...valueDef("retirement_pension_earning_capacity_applied"),
  ...valueDef("retirement_earning_capacity_company"),
  ...valueDef("living_lift_description"),
  ...valueDef("living_lift"),
  ...valueDef("living_special"),
  ...valueDef("living_situation"),
  ...valueDef("living_situation_at_home"),
  ...valueDef("domestic_situation_is_safe"),
  ...valueDef("general_practitioner_first_name"),
  ...valueDef("general_practitioner_last_name"),
  ...valueDef("general_practitioner_street"),
  ...valueDef("general_practitioner_housenumber"),
  ...valueDef("general_practitioner_zipcode"),
  ...valueDef("general_practitioner_city"),
  ...valueDef("general_practitioner_phone_number"),
  ...valueDef("insured_details_guardian_1_type"),
  ...valueDef("insured_details_guardian_1_first_name"),
  ...valueDef("insured_details_guardian_1_last_name"),
  ...valueDef("insured_details_guardian_1_street"),
  ...valueDef("insured_details_guardian_1_house_number"),
  ...valueDef("insured_details_guardian_1_zipcode"),
  ...valueDef("insured_details_guardian_1_city"),
  ...valueDef("insured_details_guardian_1_phone"),
  ...valueDef("insured_details_guardian_2_type"),
  ...valueDef("insured_details_guardian_2_first_name"),
  ...valueDef("insured_details_guardian_2_last_name"),
  ...valueDef("insured_details_guardian_2_street"),
  ...valueDef("insured_details_guardian_2_house_number"),
  ...valueDef("insured_details_guardian_2_zipcode"),
  ...valueDef("insured_details_guardian_2_city"),
  ...valueDef("insured_details_guardian_2_phone"),
  ...valueDef("reason_for_reha_clinic"),
  ...valueDef("declaration_of_intent_confirmed"),
  ...valueDef("data_transfer_consent_given"),

  // section two
  ...valueDef("site_id_number"),
  ...valueDef("case_id"),
  ...valueDef("social_worker_first_name"),
  ...valueDef("social_worker_last_name"),
  ...valueDef("social_worker_phone_number"),
  ...valueDef("social_worker_fax_number"),
  ...valueDef("communication_in_german_possible"),
  ...valueDef("communication_other_language"),
  ...valueDef("prefered_clinic_contacted"),
  ...valueDef("prefered_clinic_name"),
  ...valueDef("prefered_clinic_street"),
  ...valueDef("prefered_clinic_house_number"),
  ...valueDef("prefered_clinic_postal_code"),
  ...valueDef("prefered_clinic_city"),
  ...valueDef("prefered_clinic_phone"),
  ...valueDef("prefered_clinic_contacted_start_date"),
} as const;

type _CheckExtraKeys = ExactKeys<GKVGeneralFormData, keyof typeof model>;

export const GKVgeneralFormDefinition = convertModelDefinition(model);
